import type { V2Shift } from './content';

export function Shift({ content }: { content: V2Shift }) {
  return (
    <section className="v2-section v2-shift">
      <div className="v2-container v2-shift-grid">
        <div className="v2-shift-copy">
          <span className="v2-eyebrow" data-reveal>
            {content.eyebrow}
          </span>
          <h2 className="v2-h2" data-reveal data-reveal-delay="0.08">
            {content.title}
          </h2>
          <p className="v2-body" data-reveal data-reveal-delay="0.16">
            {content.body}
          </p>
        </div>

        <div className="v2-shift-cards">
          <article className="v2-shift-card v2-shift-old" data-reveal>
            <header>
              <span className="v2-shift-tag">{content.oldTitle}</span>
              <p>{content.oldSubtitle}</p>
            </header>
            <ul>
              {content.oldItems.map((item) => (
                <li key={item}>
                  <i className="ph ph-x" aria-hidden="true" />
                  {item}
                </li>
              ))}
            </ul>
          </article>

          <article className="v2-shift-card v2-shift-new" data-reveal data-reveal-delay="0.14">
            <header>
              <span className="v2-shift-tag">{content.newTitle}</span>
              <p>{content.newSubtitle}</p>
            </header>
            <ul>
              {content.newItems.map((item) => (
                <li key={item}>
                  <i className="ph ph-check-circle" aria-hidden="true" />
                  {item}
                </li>
              ))}
            </ul>
          </article>
        </div>
      </div>
    </section>
  );
}
